module.exports = __webpack_public_path__ + "img/green-horiz.20b8cfc1.svg";